import {
	ConsentPreference,
	type ConsentPreferences,
	CookieCategory,
	type CookiePreferences,
} from './types';

export const LEGACY_ATLASSIAN_GDPR_COOKIE_KEY = 'atl-gdpr-consent';
export const ATLASSIAN_CONSENT_COOKIE_KEY = 'atl-bsc-consent-token';
export const ATLASSIAN_SHOW_BANNER_COOKIE_KEY = 'atl-bsc-show-banner';
export const ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY = 'atl-bsc-current-locale';
export const ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY = 'atl-bsc-consent-token-fallback';
export const TESTING_LOCALE_OVERRIDE_COOKIE_KEY = 'atl-testing-locale';
export const TESTING_TOKEN_OVERRIDE_COOKIE_KEY = 'atl-testing-consents';

export const ACCEPT_ALL_PREFERENCES: CookiePreferences = {
	[CookieCategory.StrictlyNecessary]: true,
	[CookieCategory.Functional]: true,
	[CookieCategory.Marketing]: true,
	[CookieCategory.Analytics]: true,
	[CookieCategory.Unknown]: true, // Includes uncategorized cookies
};

export const ONLY_NECESSARY_PREFERENCES: CookiePreferences = {
	[CookieCategory.StrictlyNecessary]: true,
	[CookieCategory.Functional]: false,
	[CookieCategory.Marketing]: false,
	[CookieCategory.Analytics]: false,
	[CookieCategory.Unknown]: false,
};

export const DEFAULT_PREFERENCES: ConsentPreferences = {
	[CookieCategory.StrictlyNecessary]: true,
	[CookieCategory.Functional]: false,
	[CookieCategory.Marketing]: false,
	[CookieCategory.Analytics]: false,
	[CookieCategory.Unknown]: false,
	[ConsentPreference.ConsentDataUnavailable]: true,
	[ConsentPreference.ConsentedUnderGDPR]: false,
	[ConsentPreference.ConsentedUnderCPRA]: false,
	[ConsentPreference.ConsentedUnderLGPD]: false,
	[ConsentPreference.ConsentedUnderFADP]: false,
};

export const V001_SCHEMA_KEY = '001';
export const V002_SCHEMA_KEY = '002';
